export interface IUpdateDocumentSigningStatusRequest {
        envelopeRemoteId: string;
        status: string;
    }

    export class UpdateDocumentSigningStatusRequest implements IUpdateDocumentSigningStatusRequest {
        envelopeRemoteId: string;
        status: string;

        constructor(envelopeRemoteId: string, status: string) {
            this.envelopeRemoteId = envelopeRemoteId;
            this.status = status;
        }
    }
